const handleError401 = () => {
  localStorage.removeItem('token');
  window.location.replace(process.env.REACT_APP_AWS_COGNITO_LOGOUT as string);
};

export default handleError401;
